import styled, { keyframes } from "styled-components";
import Icon from "../../assets/Icon";

interface IContainerProps {
    color: keyof ISystemColors;
    size: "small" | "medium" | "large";
    disabled?: boolean,
    loading?: boolean,
}

interface IIconProps {
    loading?: boolean,
}

export const Container = styled.button<IContainerProps>`
    background-color: rgb(0,0,0,.4);
    border: none;
    display: none;
    border-radius: 50%;
    height: ${props => props.size === "small" ? "15px" : props.size === "medium" ? "30px" : "50px"};
    width: ${props => props.size === "small" ? "15px" : props.size === "medium" ? "30px" : "50px"};
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    position: absolute;
    top: 3px;
    left: 3px;
    align-items: center;
    justify-content: center;
    z-index: 1;
`;

export const PrependIcon = styled(Icon) <IIconProps>`
    width: 22px;
    margin-right: 15px;
    animation: ${props => props.loading ? SpinAnimation : ''};
    animation-duration: 1s;
    animation-iteration-count: infinite;
`;

export const AppendIcon = styled(Icon) <IIconProps>`
    margin-left: 5px;
    animation: ${props => props.loading ? SpinAnimation : ''};
    animation-duration: 1s;
    animation-iteration-count: infinite;
`;

export const SpinAnimation = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;